import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

import themes from '@bitcoin-portal/bitcoincom-pkg-theme';

import { GlobalStyle } from './styled';
import Intl from '../../i18n/hoc';

const { light } = themes;

const LayoutHome = props => {
  const { localeDir, children, locale, netlify } = props;

  return (
    <Intl locale={locale} localeDir={localeDir} netlify={netlify}>
      <ThemeProvider theme={light}>
        <>
          <GlobalStyle />
          {children}
        </>
      </ThemeProvider>
    </Intl>
  );
};

LayoutHome.propTypes = {
  children: PropTypes.node.isRequired,
  locale: PropTypes.string.isRequired,
  localeDir: PropTypes.string.isRequired,
  netlify: PropTypes.shape({}),
};

LayoutHome.defaultProps = {
  netlify: undefined,
};

export default LayoutHome;
